<template>
  <div :class="containerClassObject" class="gridelement formsectioncompound">
    <div v-if="label" :id="`${id}-label`" class="wm-field-label">
      <label :for="id" :class="{required: required}">{{ label }}</label>
    </div>
    <div class="wm-field-input">
      <select-input
        :id="id"
        :type="type"
        :name="name"
        :$v="$v"
        :options="options"
        v-model="selected"
        :class="{ error: $v.$error }"
        :disabled="disabled"
        @change="onChange"
        @focus="onFocus"
        @blur="onBlur"
      />
    </div>
    <validation-message-list
      v-if="!disabled"
      :$v="$v"
      :property-path="name"
      translation-name-space="companyForm"
    />
  </div>
</template>

<script>
/* @flow */
import ValidationMessageList from '../ValidationMessageList'
import ValidationField from './ValidatedField'
import SelectInput from './SelectInput'

export default {
  name: 'SelectField',
  components: {
    ValidationMessageList,
    SelectInput
  },
  extends: ValidationField,
  props: {
    $v: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customContainerClasses: {
      type: Array,
      required: false,
      default: () => ['small-12', 'wm-field', 'columns']
    },
    options: {
      type: Array,
      required: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    validationMessageTranslationNameSpace: {
      type: String,
      default: 'companyForm'
    }
  },
  data () {
    return {
      selected: this.value
    }
  },
  computed: {
    containerClassObject () {
      const containerClassObject = {}
      this.customContainerClasses.forEach(className => {
        containerClassObject[className] = true
      })

      return containerClassObject
    }
  },
  watch: {
    value: function (value) {
      this.selected = value
    }
  },
  methods: {
    onChange (value) {
      this.$emit('change', value)
      this.$v.$touch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/SelectField.vue